import { render, staticRenderFns } from "./BrandAmountTableAndChart.vue?vue&type=template&id=49679ce4&scoped=true"
import script from "./BrandAmountTableAndChart.vue?vue&type=script&lang=js"
export * from "./BrandAmountTableAndChart.vue?vue&type=script&lang=js"
import style0 from "./BrandAmountTableAndChart.vue?vue&type=style&index=0&id=49679ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49679ce4",
  null
  
)

export default component.exports